module.exports = __webpack_public_path__ + "img/head.bf13682b.png";